import './CreateDocumentTemplateExecutor.scss';
import React, { useState } from 'react';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { sendNotification } from '@srm/ui/lib/notifications';
import { useForm } from 'react-hook-form';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { DocumentTemplateFields } from '@organisms/actions/docExecutors/parts/DocumentTemplateFields';
import { accessTypeItems, templateAccessOf } from '@organisms/actions/docExecutors/parts/documentTemplateAccess';
import { ICreateDocumentTemplateExecutorProps } from './ICreateDocumentTemplateExecutorProps';
import { ICreateDocumentTemplateFormData } from './ICreateDocumentTemplateFormData';
import { RouteNames } from '@/router/router.types';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';

export const CreateDocumentTemplateExecutorModal: React.FC<ICreateDocumentTemplateExecutorProps> = (
    props: ICreateDocumentTemplateExecutorProps,
) => {
    const [errorText, setErrorText] = useState<string>();
    const [loading, setLoading] = useState<boolean>();

    const service = new DocumentExecutionService(props.docId);

    const formState = useForm<ICreateDocumentTemplateFormData>({
        mode: 'onBlur', // "onChange"
        defaultValues: {
            templateName: '',
            templateAccess: [accessTypeItems[0]],
            deps: '',
        },
    });
    const hasUnsavedInput = useUnsavedFormInput(formState, { textFields: ['templateName'] });

    const onSubmit = (form: ICreateDocumentTemplateFormData) => {
        const templateAccess = templateAccessOf(form.templateAccess?.[0]?.value, form.deps);

        setLoading(true);

        return service
            .createDocumentTemplate(props.actionKey, form.templateName, templateAccess)
            .then((result) => {
                props.completeHandler && props.completeHandler(true);
                sendNotification({
                    title: 'Шаблон документа успешно создан',
                    message: `<a href=${RouteNames.DOCUMENT.replace(':id', result.data)}>Перейти к документу</a>`,
                    variant: 'green',
                });
                formState.reset({ templateName: '', templateAccess: [accessTypeItems[0]], deps: '' });
            })
            .catch((error) => setErrorText(error))
            .finally(() => {
                setLoading(false);
            });
    };

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: loading,
        closeDisabled: loading,
        hasUnsavedInput,
        onCancel: () => {
            props.completeHandler && props.completeHandler(false);
        },
        errorText: errorText,
        formMethods: formState,
        onSubmit: onSubmit,
        okButtonDisabled: false,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <DocumentTemplateFields formState={formState} withDefaultAccess />
        </ModalContainer>
    );
};
